import React from 'react'
import { useTranslation } from 'react-i18next'
import { KpiCard, KPI_TONE_COLORS } from '@/components/dashboard/KpiCard'
import { KpiCardGrid } from '@/components/dashboard/KpiCardGrid'

export type BulkUploadKpiItem = {
  key: string
  labelKey: string
  fallback: string
  value: number
  tone?: 'default' | 'blue' | 'emerald' | 'amber' | 'purple' | 'red'
}

type BulkUploadKpiGridProps = {
  items: BulkUploadKpiItem[]
  columns?: 2 | 3 | 4 | 6
}

const gridCols: Record<NonNullable<BulkUploadKpiGridProps['columns']>, string> = {
  2: 'grid-cols-1 sm:grid-cols-2',
  3: 'grid-cols-1 sm:grid-cols-2 lg:grid-cols-3',
  4: 'grid-cols-1 sm:grid-cols-2 lg:grid-cols-4',
  6: 'grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-6',
}

export const BulkUploadKpiGrid: React.FC<BulkUploadKpiGridProps> = ({ items, columns = 6 }) => {
  const { t } = useTranslation(['BulkPodUpload'])

  return (
    <KpiCardGrid className={gridCols[columns]}>
      {items.map((item, index) => {
        const tone = item.tone ?? 'default'
        const color = KPI_TONE_COLORS[tone] ?? KPI_TONE_COLORS.default
        return (
          <KpiCard
            key={item.key}
            title={t(`BulkPodUpload:${item.labelKey}`, item.fallback)}
            count={item.value}
            color={color}
            delay={index * 0.04}
          />
        )
      })}
    </KpiCardGrid>
  )
}

export default BulkUploadKpiGrid
